import { PrimaryButton } from 'components/UI/Buttons'
import { tasksFeedsSteps } from 'features/tasks/list/help'
import {
  useCountCompanyProjectsQuery,
  useMeQuery,
  useUpdateMyUserMutation
} from 'generated/graphql'
import React from 'react'
import { useLocation } from 'react-router-dom'
import Tour from 'reactour'
import { theme } from 'theme'
import { HelpMapType, TourGuideProps } from './types'
import { projectListSteps } from 'features/projects/list/help'
import { createCommunityHelperSteps } from 'features/communities/create/help'

import { VscArrowRight, VscChevronRight } from 'react-icons/vsc'
import { createTaskTypeSteps } from 'features/task-builder/create/help'
import { helpAndSupportHelperTourGuideSteps } from 'features/help/help'

const TourGuide: React.FC<TourGuideProps> = ({ customSteps, customType }) => {
  const location = useLocation()
  const { pathname } = location

  const { data: me, loading, refetch } = useMeQuery()
  const { data: projects } = useCountCompanyProjectsQuery({})
  const numberOfProjects = projects?.countCompanyProjects || 0
  const hasProjects = numberOfProjects > 0
  const helpMap: HelpMapType = hasProjects
    ? {
        '/auth/tasks': {
          type: 'tasksFeed',
          steps: tasksFeedsSteps
        },
        '/auth/': {
          type: 'tasksFeed',
          steps: tasksFeedsSteps
        },
        '/auth/projects': {
          type: 'projectsList',
          steps: projectListSteps
        },
        '/auth/create-community': {
          type: 'createGroup',
          steps: createCommunityHelperSteps
        },
        '/auth/task-types-list/create-task': {
          type: 'createTaskType',
          steps: createTaskTypeSteps
        },
        '/auth/help': {
          type: 'helpAndTraining',
          steps: helpAndSupportHelperTourGuideSteps
        }
      }
    : ({} as HelpMapType)

  const { type: innerType, steps: innerSteps } = hasProjects
    ? helpMap?.[pathname] || {
        type: '',
        steps: []
      }
    : {
        type: '',
        steps: []
      }

  const type = customType || innerType
  const steps = customSteps || innerSteps

  const [updateMyUser] = useUpdateMyUserMutation({
    onCompleted: async () => {
      await refetch()
    }
  })

  const guideType = me?.myUser?.attributes?.onboardingInformation?.guideWizard?.[type]
  const [isOpen, setIsHelpGuideOpen] = React.useState(guideType)

  const onClose = () => {
    setIsHelpGuideOpen(false)
  }

  React.useEffect(() => {
    setIsHelpGuideOpen(guideType === false ? false : true)
  }, [guideType])

  return (
    <Tour
      steps={steps}
      isOpen={Boolean(isOpen && !loading && type)}
      onRequestClose={onClose}
      inViewThreshold={0.5}
      accentColor={theme.colors.brand[400]}
      onAfterOpen={() => (document.body.style.overflowY = 'hidden')}
      lastStepNextButton={
        <PrimaryButton
          onClick={() => {
            onClose()
          }}
          rightIcon={<VscArrowRight />}
        >
          Get Started
        </PrimaryButton>
      }
      nextButton={<PrimaryButton rightIcon={<VscChevronRight />}>Next</PrimaryButton>}
      rounded={6}
      onBeforeClose={async () => {
        document.body.style.overflowY = 'auto'
        await updateMyUser({
          variables: {
            input: {
              onboardingInformation: {
                ...me?.myUser?.attributes?.onboardingInformation,
                guideWizard: {
                  ...me?.myUser?.attributes?.onboardingInformation?.guideWizard,
                  ...(type && { [type]: false })
                }
              }
            }
          }
        })
      }}
    />
  )
}

export default TourGuide
